import React from 'react';
import PropTypes from 'prop-types';
import ButtonSquare from './BasicButton';


const ButtonText = (props) => {
  const {
    children, theme, link, active,
  } = props;
  const textStyle = {
    fontFamily: 'Open Sans',
    fontSize: '14px',
    textTransform: 'uppercase',
    padding: '5px 15px',
    color: 'white',
  };
  if (theme === 'dark') {
    textStyle.color = '#2f1275';
  } else if (theme === 'light') {
    textStyle.color = 'white';
  }
  return (
    <ButtonSquare link={link} active={active}>
      <div style={textStyle}>
        {children}
      </div>
    </ButtonSquare>

  );
};

ButtonText.defaultProps = {
  children: null,
  theme: 'light',
  link: '#',
  active: false,
};

ButtonText.propTypes = {
  children: PropTypes.node,
  theme: PropTypes.string,
  link: PropTypes.string,
  active: PropTypes.bool,
};

export default ButtonText;



// WEBPACK FOOTER //
// ./src/components/ButtonSquare/ButtonText.jsx